import clsx from "clsx";
import { useLayoutEffect } from "react";
import { useWatch } from "react-hook-form";
import ControlledSingleSelect from "components/Form/Select/SingleSelect";
import { ControlledSelectProps } from "components/Form/Select";
import { useFloatingField } from "./context";
import { sizeStyles } from "./sizeStyles";

function FloatingStaticSelect({ control, name, placeholder = "", ...rest }: ControlledSelectProps) {
  const { setHasValue, hasValue, size } = useFloatingField();
  const styles = sizeStyles[size];
  const value = useWatch({ control, name });

  useLayoutEffect(() => {
    setHasValue(!!value);
  }, [value, setHasValue]);

  return (
    <div className={clsx("floating-single-select", hasValue && "chakra-react-select--has-value")}>
      <ControlledSingleSelect
        {...rest}
        control={control}
        name={name}
        placeholder={placeholder}
        chakraStyles={{
          control: (provided: any) => ({
            ...provided,
            height: styles.inputHeight,
            minHeight: styles.inputHeight,
            maxHeight: styles.inputHeight,
            cursor: "pointer",
            backgroundColor: "transparent",
          }),
          valueContainer: (provided: any) => ({
            ...provided,
            paddingLeft: 0,
            paddingInlineStart: 0,
          }),
          option: (provided: any) => ({
            ...provided,
            color: "fg.muted",
          }),
        }}
      />
    </div>
  );
}

export default FloatingStaticSelect;
